export const endpoints = {
  search: {
    autocomplete: () => "/api/v1/internal/search/autocomplete"
  }
};
